import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Layout from "../../components/Layout";
import { DE } from "../../Languages/DE";
import { EN } from "../../Languages/EN";
import LanguageContext from "../../helper/LanguageContext";
import { callAPI } from "../../helper/apiUtils";
import {
  EmailIcon,
  EmailShareButton,
  TelegramIcon,
  TelegramShareButton,
  WhatsappIcon,
  WhatsappShareButton,
} from "react-share";
import { $crud } from "../../helper/CrudFactory";
import "./Invite.css";

const QRCode = require("qrcode.react");

function Invite(props) {
  const { isGerm, strings } = React.useContext(LanguageContext);
  const [company, setCompany] = useState(null);
  const [compDetail, setCompanyDetail] = useState(null);
  const [deeplink, setDeepLink] = useState("");
  const [toggleShareLink, setToggleShareLink] = useState(false);
  const [showQrCode, setQrCode] = useState(false);
  const [depname, setDepname] = useState([])
  const [isKjuup, setIsKjuup] = useState([])
  console.log(props.match.params.departmentId)
  let iPhoneText = strings.iphone_recivers_message;
  let iphone = strings.iphone;
  let germenLangDeeplink =
    `${DE.company_receivers_message}\n\n${deeplink}`.replaceAll(
      "company name",
      company?.name
    ).replaceAll('department', depname)
  let engLangDeeplink =
    `${EN.company_receivers_message}\n\n${deeplink}`.replaceAll(
      "company name",
      company?.name
    ).replaceAll('department', depname)
  let germenLangDeeplinkDep =
    `${DE.company_sender_message_dep}\n\n${deeplink}`.replaceAll(
      "company name",
      company?.name
    ).replaceAll('depname', depname)
  let engLangDeeplinkDep =
    `${EN.company_sender_message_dep}\n\n${deeplink}`.replaceAll(
      "company name",
      company?.name
    ).replaceAll('depname', depname)
  const receiverMessage = deeplink
    ? isGerm
      ? (props.match.params.departmentId && props.match.params.departmentId !== 'null') ? germenLangDeeplinkDep : germenLangDeeplink
      : (props.match.params.departmentId && props.match.params.departmentId !== 'null') ? engLangDeeplinkDep : engLangDeeplink
    : "";

  // const receiverMessage = deeplink
  //   ? `${
  //       strings.company_receivers_message
  //     }\n\n${deeplink}`.replaceAll("company name", company?.name)
  //   : "";
  useEffect(() => {
    if (props.location.state) {
      setIsKjuup(props.location.state.isKjuup)
    }
  }, [props])
  useEffect(() => {
    _getDep()
  }, [props.match.params.departmentId])
  const _getDep = async () => {
    const { data } = await callAPI(`/company/getDeptLocation/${props.match.params.id}`, {}, "GET");
    if (data.status) {
      let dd = data.data.getCompanyDept.filter(e => e.id == props.match.params.departmentId)
      console.log(dd, props)
      if (dd.length > 0) {
        let obj = dd[0]
        if (obj.department_name && (obj.location_name && obj.location_name != 'null'))
          setDepname(obj.department_name + "/" + obj.location_name)
        else
          setDepname(obj.department_name)
      }
    }
  }
  const getCompanyDetails = async () => {
    const id = props.match.params.id;
    const datax = await callAPI(`/company/${id}/profile`, {}, "GET");
    await setCompanyDetail(datax.data.profile);
    const { data } = await callAPI(`/company/${id}/companyById`, {}, "GET");
    await setCompany(data.company);
  };
  const getInviteLink = async () => {
    const id = props.match.params.id;
    const { data } = await callAPI(
      `/invite-user/deeplink`,
      (props.match.params.departmentId && props.match.params.departmentId !== 'null') ? {
        inviteType: "company",
        company: id,
        deptLocation: props.match.params.departmentId,
        isImportCompany: compDetail.isImport ? 1 : 0
      } : {
        inviteType: "company",
        company: id,
        isImportCompany: compDetail.isImport ? 1 : 0
      },
      "POST"
    );
    if (data.status) {
      let splitToken = data?.deeplinkUrl?.split("/");
      let getToken = splitToken[splitToken?.length - 1];
      let webLinkPayload = {
        data: {
          locallyIndex: true,
          title: "Kjuup",
          ratingAverage: 4.2,
          registraTionToken: getToken,
          isKjuupPlus: compDetail.isKjuup ? "true" : "false",
          deptLocation: props.match.params.departmentId,
          isImportCompany: compDetail.isImport ? 1 : 0
        },
      };
      window.branch.link(webLinkPayload, (err, link) => {
        setDeepLink(link);
      });
      // setDeepLink(data.deeplinkUrl);
    }
  };
  useEffect(() => {
    if (compDetail) {
      console.log(compDetail)
      getInviteLink()
    }
  }, [compDetail])
  useEffect(() => {
    getCompanyDetails();
  }, [props.match.params.id]);

  const handleShareUrl = () => {
    setToggleShareLink(!toggleShareLink);
    setQrCode(false);
  };
  const handleQrCode = () => {
    setToggleShareLink(false);
    setQrCode(!showQrCode);
  };

  const handleCopy = async () => {
    console.log(receiverMessage)
    setToggleShareLink(false);
    setQrCode(false);
    navigator.clipboard.writeText(receiverMessage).then((r) => {
      $crud.notify({
        type: "success",
        message: strings.link_copied,
      });
    });
  };
  const handleCancel = async () => {
    setToggleShareLink(false);
    setQrCode(false);
    const id = props.match.params.id;
    const { data } = await callAPI(`/company/${id}/deeplink`, {}, "DELETE");
    if (data.status) {
      setDeepLink(data.deeplinkUrl);
    }
  };

  return (
    <React.Fragment>
        <div className="p-0 company-invite d-flex flex-column">
          <div className="company_header  company_list company_border company-invite__header">
            <div className="heading_icon m-0 company-invite__heading-icon">
              <Link
                to={{ pathname: "/cockpit", search: `?tab=company&company=${encodeURIComponent(props.match.params.id)}` }}
                className={isKjuup ? "main_heading main_heading-internal company-invite__back-link" : "main_heading company-invite__back-link"}
              >
                <span className={`material-symbols-outlined material-arrow-left ${isKjuup ? 'internal-arrow' : ''}`}>
                  keyboard_arrow_left
                </span>
                {strings.invite_with_link}
              </Link>
            </div>
          </div>
          <div className="p-2 w-300 company_border">
            {company?.name ? (
              <>
                <div>
                  {`${strings.company_sender_message
                    }`.replaceAll("company name", company?.name || "")}
                </div>
              </>
            ) : (
              <span>{strings.Loading}</span>
            )}
          </div>

          <div
            className="profile_name row m-0 text-center pt-2 company-invite__actions"
          >
            <div className="col-md-4">
              <div onClick={handleCopy} className="pointer">
                {isKjuup ?
                  <img
                    width={30}
                    src={process.env.PUBLIC_URL + "/assets/img/copy_green.svg"}
                  />
                  :
                  <img
                    width={30}
                    src={process.env.PUBLIC_URL + "/assets/img/Copy link.svg"}
                  />
                }
                <br />
                <span
                  className={`company-invite__copy-label${isKjuup ? " company-invite__copy-label--internal" : ""}`}
                >
                  {strings.copy_link}
                </span>
              </div>
            </div>
            <div className="company-invite__expiry">
              <span className="company-invite__expiry-text">
                {(() => {
                  const text = strings.link_expire;
                  return text
                    .replace('72 hours', '10 days')
                    .replace('72 ore', '10 giorni')
                    .replace('72 Stunden', '10 Tage')
                    .replace('72 heures', '10 jours')
                    .replace('72 horas', '10 días')
                    .replace('72 uur', '10 dagen')
                    .replace('72 timer', '10 dager')
                    .replace('72 timmar', '10 dagar')
                    .replace('72 tuntia', '10 päivää')
                    .replace('72 godziny', '10 dni')
                    .replace('72 saat', '10 gün')
                    .replace('72 ώρες', '10 ημέρες')
                    .replace('72 hodin', '10 dní')
                    .replace('72 óra', '10 nap')
                    .replace('72 de ore', '10 zile')
                    .replace('72 часа', '10 дни')
                    .replace('72 sata', '10 dana')
                    .replace('72 ur', '10 dni')
                    .replace('72小时', '10天')
                    .replace('72 घंटे', '10 दिन')
                    .replace('72 ساعة', '10 أيام')
                    .replace('72時間', '10日')
                    .replace('72시간', '10일')
                    .replace('72 giờ', '10 ngày')
                    .replace('72 jam', '10 hari')
                    .replace('72 மணி', '10 நாட்கள்')
                    .replace('72 గంటలు', '10 రోజులు')
                    .replace('72 часа', '10 дней');
                })()}
              </span>
            </div>
          </div>
          {toggleShareLink && (
            <div className="mt-3 p-2">
              <h6>{strings.share_on} </h6>
              <WhatsappShareButton className="mr-1" url={receiverMessage}>
                <WhatsappIcon size={30} round={true} />
              </WhatsappShareButton>
              <EmailShareButton className="mr-1" url={receiverMessage}>
                <EmailIcon size={30} round={true} />
              </EmailShareButton>
              <TelegramShareButton className="mr-1" url={receiverMessage}>
                <TelegramIcon size={30} round={true} />
              </TelegramShareButton>
            </div>
          )}
          {showQrCode && (
            <div className="text-center pt-3">
              <QRCode value={receiverMessage} />
            </div>
          )}
        </div>
    </React.Fragment>
  );
}

export default Invite;
